/*
|
|               Light
_______________________________________________
|
|    This class keep all fields for 
|    new light. Using in zones manipulation 
|
*/

import { Product } from './Product';

export class Light {
    id                   :any;
    baseType             :any;
    compare              :boolean = false;
    description          :any;
    dailyUse             :number;
    manufacturer         :any;
    entity               :string = '';
    entityID             :any;
    existingID?          :any;
    existingDescription? :any;
    existingProductType? :string = '';
    groupColor?          :any;
    groupPosition?       :any;
    groupType?           :any;
    link?                :boolean = true;
    linkedDescription?   :string = '';
    linkedProducts?      :any;
    linkedProductType?   :string = '';
    mainProduct?         :any;
    mainProductID?       :any;
    mainProductType?     :string = '';
    Notes                :string = '';
    navyColor?           :boolean = false;
    product?             :Product;
    productType          :any;
    quantity             :number;
    scheduleType         :string = '';
    type                 :string = '';
    weeklyUse            :number;
    yearlyUse            :number;
    video?               :any;
    withLinked           :boolean = true;
    zoneID               :any;
    option               :string = '';
}


// WEBPACK FOOTER //
// /root/anvel/angular/classes/Light.ts